var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',[_c('Banner'),_c('WhyUs'),_c('SubBanner'),_c('KeyProduct'),_c('Featured')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }